import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import {
  BsArrowLeftCircle, BsArrowRepeat, BsArrowRightShort, BsBarChartLine,
  BsBoxArrowInDown, BsBoxSeam, BsCalculator, BsCart4, BsCash, BsCashStack, BsClipboardCheck,
  BsClockHistory, BsCreditCard, BsCurrencyDollar, BsFileEarmarkText,
  BsGift, BsListTask, BsLock, BsPeople, BsPersonBadge
} from "react-icons/bs";
import { FaSearch } from "react-icons/fa";
import { MdCurrencyRupee, MdOutlineViewList, MdVerified } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import './report.css'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign } from "@fortawesome/free-solid-svg-icons";

const ReportPage: React.FC = () => {
  const navigate = useNavigate();
  const isMainStoreEnabled = (localStorage.getItem("isMainStore") ?? "false") === "true";

  const reports = [
    { title: "Daily Report", icon: <BsListTask />, path: "/daily-report" },
    { title: "Revenue Report", icon: <BsCash />, path: "/daily-collection-report" },
    // { title: "Day End Report", icon: <BsClockHistory />, path: "/day-end-report" },
    // { title: "Margin Report", icon: <BsBarChartLine />, path: "/margin-report" },
    { title: "Stock Report", icon: <BsBoxSeam />, path: "/stock-report" },
    // { title: "Physical Verification Report", icon: <FaSearch />, path: "/physical-verification-report" },
    { title: "Inward Report", icon: <MdVerified />, path: "/inward-report" },
    { title: "Advance Report", icon: <MdOutlineViewList />, path: "/advance-report" },
    { title: "OG Purchase Report", icon: <BsCart4 />, path: "/og-purchase-report" },
    ...(isMainStoreEnabled
      ? [
        {
          title: "Gold Rate Log Report",
          icon: <FontAwesomeIcon icon={faIndianRupeeSign} />,
          path: "/goldRate-log-report",
        },
      ]
      : []),
    // { title: "Sales Report", icon: <BsCashStack />, path: "/sales-report" },
    // { title: "Sales Return Report", icon: <BsArrowRepeat />, path: "/sales-return-report" },
    // { title: "Cash Report", icon: <BsCurrencyDollar />, path: "/cash-report" },
    // { title: "Customer Report", icon: <BsPeople />, path: "/customer-report" },
    // { title: "Staff Wise Sales Report", icon: <BsPersonBadge />, path: "/staff-wise-sales-report" },
    // { title: "EOD Report", icon: <BsClipboardCheck />, path: "/eod-report" },
    // { title: "Collection Report", icon: <BsCalculator  />, path: "/collection-report" },
    // { title: "Customer Ledger Report", icon: <BsFileEarmarkText />, path: "/customer-ledger-report" },
    // { title: "Return to Hk Report", icon: <BsArrowLeftCircle />, path: "/return-to-hk-report" },
    // { title: "As On Stock", icon: <BsBoxSeam />, path: "/as-on-stock" },
    { title: "Reward Report", icon: <BsGift />, path: "/reward-report" },
    // { title: "Reconciliation Report", icon: <BsBarChartLine />, path: "/reconciliation-report" },
    // { title: "Closing Report", icon: <BsLock />, path: "/closing-report" },
  ];

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <div className="container" style={{ marginTop: "5rem", marginBottom: "3rem" }}>
      <h2 className="mb-4">Reports</h2>
      <Row>
        {reports.map((report, index) => (
          <Col md={3} sm={5} xs={12} key={index} className="mb-4">
            <Card
              className="text-center p-3 report-card"
              onClick={() => handleCardClick(report.path)}
            >
              <Card.Body>
                <div className="fs-1 mb-2">{report.icon}</div>
                <Card.Title>{report.title}</Card.Title>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default ReportPage;
